<template>
    <div>
        <div class="header-inner">
            <van-icon name="arrow-left" class="left-icon" @click="$router.push({ name: 'index' })" />
            <h2>实时提现榜</h2>
        </div>
        <div class="banner">
                <div class="nowCash-inner" v-for="(item, i) in realCashList" :key="i">
                    <div class="cash-name">
                        <img src="../../assets/bx/dj/icon.png" alt="">
                        <p class="name">{{ item.rn_name }}</p>
                    </div>
                    <div class="cashSum">
                        <p class="cashAlready">
                            <img src="../../assets/bx/dj/success.png" alt="">
                            <span> 已提现,打款至支付宝</span>
                        </p>
                        <p class="cash-success">成功提现{{ item.amount }}元,总计提现{{ item.total_amount }}元</p>
                    </div>
                    <p class="timeAgo">{{ item.ctime }}</p>
                </div>
            </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            realCashList: [],
        }
    },
    computed: {
    },
    created() {
    },
    mounted() {
        this.getRealCash()
    },
    methods: {
        // 实时
        getRealCash() {
            this.$Ajax('user-cash/real-cash', {}, 'get').then(rs => {
                if (rs.code == 200) {
                    this.realCashList = rs.data.list.slice(0,25)
                }
            })
        },
    }
};
</script>

<style scoped lang="less">

.header-inner {
        position: fixed;
        top: 0;
        left: 50%;
        width: 100%;
        max-width: 525px;
        transform: translateX(-50%);
        text-align: center;
        overflow: hidden;
        display: flex;
        background: linear-gradient(33deg, #ff625a 0%, #df5f56 80%);
        height: 6rem;
        color: #fff;
        z-index: 100;

        h2 {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
        }

        .van-icon {
            position: absolute;
            left: 1rem;
            top: 50%;
            transform: translateY(-50%);
            font-size: 2rem;
            vertical-align: middle;
            cursor: pointer;
        }

    }
.banner {
    margin-top: 6rem;
    padding-top: 1.5rem;
        .nowCash-inner {
            height: 8rem;
            background-color: white;
            border-radius: .6rem;
            margin: 0 1.5rem 1rem;
            display: flex;
            align-items: center;
            position: relative;
            padding: .5rem;

            .cash-name {
                display: flex;
                align-items: center;
                margin-left: .5rem;

                img {
                    width: 5rem;
                    height: 5rem;
                }

                .name {
                    width: 5rem;
                    padding-left: .5rem;
                    font-size: 1.2rem;
                }
            }

            .cashSum {
                margin: 3rem;

                .cashAlready {
                    width: 15rem;
                    height: 1.8rem;
                    background-color: #fe6455;
                    color: white;
                    font-size: .8rem;
                    border-radius: 15px;
                    text-align: center;
                    line-height: 1.8rem;
                    margin-bottom: .5rem;
                    img {
                        width: 1rem;
                        height: 1rem;
                        // vertical-align: baseline;
                    }
                }

                .cash-success {
                    color: #adadad;
                }
            }

            .timeAgo {
                position: absolute;
                top: .5rem;
                right: .5rem;
                color: #adadad;
            }
        }
    }
</style>
